module.exports = __webpack_public_path__ + "static/media/classStudentTemp.2918f2c1.xlsx";